import { globalHistory } from '@reach/router'
import dayjs from 'dayjs'
import Cookies from 'js-cookie'

// 型定義
export interface UserData {
    UserKey: string
    Birthday: string
    FcElement: FcElement
    _onePeriodExtension?: boolean
    [key: string]: any
}

export interface FcElement {
    FcStatus: number
    FcExpDate: string
    FcExpLimitDate: string
    [key: string]: any
}

export interface ValidateTicketResponse {
    ErrCode: string
    ErrDetail: string
    Expiration: string
    Expired: string
    UserKey: string
    Result: string
}

export interface FcUserResponse {
    FcElements: {
        FcExpansionElement?: FcElement | FcElement[]
    }
    Result: string
    [key: string]: any
}

export interface LoginCallbacks {
    successCallback: () => void
    cancelCallback: () => void
    errorCallback: (error: any) => void
}

export interface LogoutOptions {
    callback: () => void
}

// ユーティリティ関数
export const isBrowser = (): boolean => typeof window !== "undefined"

export const getUser = (): UserData | null => {
    const user = Cookies.get('user')
    console.log("user=>", user)
    
    if (!isBrowser() || !user) {
        return null
    }
    
    // 既にオブジェクトの場合はそのまま返す
    if (typeof user === 'object') {
        return user as UserData
    }
    
    // 文字列の場合はJSON.parseを試す
    try {
        return JSON.parse(user) as UserData
    } catch (error) {
        console.error('Failed to parse user cookie:', error)
        return null
    }
}

const checkErrorCount = (): boolean => {
    const count = Number(Cookies.get('error_count'))
    if (count > 2) {
        Cookies.set('error_count', '0', { path: '/' })
        return true
    }
    return false
}

const validateTicket = async (ticket: string): Promise<ValidateTicketResponse | null> => {
    try {
        console.log("res", JSON.stringify({ ticket: ticket }))
        const params: RequestInit = {
            method: "POST",
            body: JSON.stringify({ ticket: ticket }),
            headers: { 
                "Content-Type": "application/json"
            },
        }
        
        const res = await fetch(`${process.env.GATSBY_MODD_API_VALIDATE_TICKET}`, params)
        const result = await res.json()
        const data = await JSON.parse(result.data)
        return data as ValidateTicketResponse
    } catch (error: any) {
        console.log(`Error: ${error}`)
        return null
    }
}

export const getFcUser = async (userKey?: string): Promise<FcUserResponse | null> => {
    console.log("userKey", userKey)
    
    if (!userKey) {
        userKey = Cookies.get('user_key')
    }
    
    if (!userKey) return null

    try {
        const params: RequestInit = {
            method: "POST",
            body: JSON.stringify({ userKey: userKey }),
            headers: { 
                'Content-Type': 'application/json',
            },
        }
        
        const res = await fetch(`${process.env.GATSBY_MODD_API_GET_USER}`, params)
        const result = await res.json()
        const json = await JSON.parse(result.data)
        console.log("getFcUser=>", json)
        return json as FcUserResponse
    } catch (e) {
        console.log(`Error: ${e}`)
        return null
    }
}

export const checkLogin = async ({
    successCallback, 
    cancelCallback, 
    errorCallback
}: LoginCallbacks): Promise<boolean> => {
    const { location } = globalHistory
    const params = new URLSearchParams(location.search)
    let ticket = params.get('ticket')
    
    console.log(location)
    console.log("Cookies->", Cookies.get("logined"))

    try {
        // チケットの取得とURL書き換え
        if (ticket) {
            Cookies.set('ticket', ticket, { path: '/' })
            window.history.replaceState('', '', `${location.pathname}`)
            const logined = Cookies.get("logined")
            if (logined !== "true") {
                // ログイン処理をしてなかった場合は不正
                // throw "Error: -1"
            }
        } else {
            ticket = Cookies.get('ticket') || null
        }
        
        console.log("ticket", ticket)
        if (!ticket) {
            if (cancelCallback) {
                cancelCallback()
            }
            throw `Error: 000 ${ticket}`
        }

        if (checkErrorCount()) {
            throw `Error: 999 ${ticket}`
        }
        
        // チケット検証
        const vtr = await validateTicket(ticket)
        if (!vtr) {
            console.log("vtr", vtr)
            throw "Error: 110"
        }
        
        console.log('api', vtr)
        if (vtr.ErrCode !== "" && (typeof vtr.ErrCode === 'string' || vtr.Result !== "1")) {
            throw `[MODD API Error Code: ${vtr.ErrCode}] ${vtr.ErrDetail}`
        }
        
        // ユーザーキーの検証
        const ukey = Cookies.get('user_key')
        if (ukey && ukey !== vtr.UserKey) {
            console.log("userKey update")
            Cookies.set('user_key', vtr.UserKey)
        }

        if (vtr.Expired === 'true') {
            Cookies.remove('ticket', { path: '/' })
            Cookies.remove('user_key', { path: '/' })
            Cookies.remove('user', { path: '/' })
            throw "Error: 111"
        }

        // ユーザー情報取得
        const gfu = await getFcUser(vtr.UserKey)
        console.log("gfu===>", gfu)
        if (!gfu) {
            throw 'Error: 120'
        }
        
        console.log(gfu)
        let currentFcElement = gfu.FcElements.FcExpansionElement || gfu.FcElements
        currentFcElement = Array.isArray(currentFcElement) ? currentFcElement[0] : currentFcElement
        
        if (!currentFcElement) {
            throw 'Error: 121'
        }
        
        console.log("currentFcElement=>", currentFcElement)
        
        // 会員状態の確認
        const { FcStatus, FcExpDate, FcExpLimitDate } = currentFcElement as FcElement
        // console.log("FcExpansionElement=>", FcStatus)
        // console.log('api error', FcStatus, FcExpLimitDate)
        
        // 会員状態が活動会員でない場合はエラー
        let onePeriodExtension = false
        if (FcStatus !== 0) {
            console.log('api error', currentFcElement)
            // 会員切れから一ヶ月以内は猶予
            const limit = dayjs(FcExpLimitDate)
            const limitToday = dayjs()
            const diff = limit.diff(limitToday, "day")
            // const diff = dayjs("20251027").diff(limitToday, "day")
            // console.log("diff===>", diff, limit.format('YYYY-MM-DD'), limitToday.format('YYYY-MM-DD'))
            // console.log("diff2===>",dayjs("20251031").diff(limitToday, "day") , dayjs("20251031").format('YYYY-MM-DD'), limitToday.format('YYYY-MM-DD'))
            
            if (diff > 0) {
                onePeriodExtension = true
            } else {
                throw 'Error: 122'
            }
        }
        
        console.log('<<<<<< login ok >>>>>>')
        console.log("error", Cookies.get('error_count'))

        const today = new Date()
        const tomorrow = new Date()
        tomorrow.setDate(today.getDate() + 1)

        Cookies.set('error_count', '0', { path: '/' })
        Cookies.set('user_key', vtr.UserKey, { expires: tomorrow, path: '/' })
        const user = JSON.stringify({
            UserKey: vtr.UserKey,
            Name1: gfu.Name1,
            Name2: gfu.Name2,
            Email: gfu.Email,
            Birthday: gfu.Birthday,
            cryptoId: gfu.cryptoId,
            FcElement: currentFcElement,
            _onePeriodExtension: onePeriodExtension
        })
        console.log("user=>1", user)
        Cookies.set('user', user, { expires: tomorrow, path: '/' })

        console.log('user=>2', Cookies.get('user'))
        
        if (successCallback) {
            successCallback()
        }
        
        return true
    } catch (error: any) {
        if (errorCallback) {
            errorCallback(error)
        }
        return false
    }
}

export const isLoggedIn = (): boolean => {
    const user = getUser()
    const key = Cookies.get("user_key")
    console.log("user=>login", key, user)
    
    if (user && user.UserKey) {
        if (user.UserKey === key) {
            return true
        }
    }
    return false
}

export const logout = ({ callback }: LogoutOptions): void => {
    // エラーカウントの更新
    let count = Number(Cookies.get('error_count'))
    if (!count) {
        count = 0
    }
    Cookies.set('error_count', count.toString(), { path: '/' })
    console.log("error", Cookies.get('error_count'))

    // クッキーの削除
    Cookies.remove('ticket', { path: '/' })
    Cookies.remove('user_key', { path: '/' })
    Cookies.remove('user', { path: '/' })
    
    // memberパスのクッキーも削除
    Cookies.remove('ticket', { path: '/member' })
    Cookies.remove('user_key', { path: '/member' })
    Cookies.remove('user', { path: '/member' })

    if (callback) {
        callback()
    }
}